unit unit_Tickets;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, DB;

type
  TTickets = class(TForm)
    xdsTickets: TXDataWebDataSet;
    TC: TTableControl;
    xdsTicketsStatus: TXDataWebEntityField;
    xdsTicketsID: TIntegerField;
    xdsTicketsErstelltAm: TDateTimeField;
    xdsTicketsBetreff: TStringField;
    xdsTicketsBeschreibung: TStringField;
    xdsTicketsErledigtAm: TDateTimeField;
    xdsTicketsLoesung: TStringField;
    xdsTicketsZeitaufwandMinuten: TIntegerField;
    xdsTicketsAbzurechnendeMinuten: TIntegerField;
    xdsTicketsAbgerechneteMinuten: TIntegerField;
    xdsTicketsStatusStatus: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsTicketsAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    mybuttonDetails:TButton;
    buttonzurueck:TButton;
    procedure mybuttonDetailsclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Tickets: TTickets;

implementation
  uses unit1, unit2, unit_EinzelTicket;
{$R *.dfm}

procedure TTickets.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TTickets.mybuttonDetailsclick(Sender:TObject);
var
  LFrm:TEinzelTicket;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TEinzelTicket;
    begin
      LForm:=(AForm as TEinzelTicket);


      //lform.MerkerAuftrag:=xdsauftragNummerkomplett.asstring;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //MerkerKontaktnummer:=lfrm.Kontaktnummer;
      //edtkontaktnummer.Text:=lfrm.Kontaktnummer;
      //edtkontaktnummerChange(nil);
      //noch implementieren
    end;
  begin
    LFrm:=TEinzelTicket.CreateNew(@AfterCreate);
    with sender as TButton do
    begin
      lfrm.MerkerTicket:=inttostr(tag);
    end;
    //LFrm.Popup:=true;
    LFrm.ShowModal(@AfterShowmodal);

end;

procedure TTickets.WebFormShow(Sender: TObject);
begin
  xdsTickets.Close;
  xdsTickets.QueryString:='$expand=Status&$filter=Kundennummer eq '+QuotedStr(KundeKundennummer)+'&$orderby=ErstelltAm DESC' ;
  xdsTickets.Load;
end;

procedure TTickets.xdsTicketsAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin

  TC.ColCount:=6;
  tc.RowCount:=xdsTickets.RecordCount+4;
  TC.Cells[0,i]:='<h4>Tickets';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  inc(i);
  tc.Cells[0,i]:='<b>Nummer';
  tc.Cells[1,i]:='<b>Datum';
  tc.Cells[2,i]:='<b>Status';
  tc.Cells[3,i]:='<b>Betreff';
  tc.Cells[4,i]:='<b>Zeitaufwand';
  tc.Cells[5,i]:='<b>abgerechnet';
  xdstickets.First;
  while not xdstickets.eof do
  begin
    inc(i);
    tc.Cells[0,i]:=xdsticketsid.AsString+' ';

    myelement:=TC.cellelements[0,i];
    mybuttonDetails:=TButton.Create(self);
    mybuttonDetails.ElementClassName:='btn btn-info text-left';
    mybuttonDetails.HeightStyle:=ssauto;
    mybuttonDetails.WidthStyle:=ssauto;
    mybuttonDetails.tag:=xdsticketsid.AsInteger;
    mybuttonDetails.Caption:='Details';
    mybuttonDetails.OnClick:=@mybuttonDetailsClick;
    mybuttonDetails.ParentElement:=myelement;

    tc.Cells[1,i]:=formatdatetime('DD.MM.YYYY hh:mm:ss',xdsTicketsErstelltAm.asdatetime);
    tc.Cells[2,i]:=xdsTicketsStatusStatus.AsString;
    tc.Cells[3,i]:=xdsTicketsBetreff.AsString;
    tc.Cells[4,i]:=xdsTicketsZeitaufwandMinuten.AsString;
    tc.Cells[5,i]:=xdsTicketsAbzurechnendeMinuten.AsString;
    xdstickets.Next;
  end;
end;

procedure TTickets.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsTickets := TXDataWebDataSet.Create(Self);
  xdsTicketsStatus := TXDataWebEntityField.Create(Self);
  xdsTicketsID := TIntegerField.Create(Self);
  xdsTicketsErstelltAm := TDateTimeField.Create(Self);
  xdsTicketsBetreff := TStringField.Create(Self);
  xdsTicketsBeschreibung := TStringField.Create(Self);
  xdsTicketsErledigtAm := TDateTimeField.Create(Self);
  xdsTicketsLoesung := TStringField.Create(Self);
  xdsTicketsZeitaufwandMinuten := TIntegerField.Create(Self);
  xdsTicketsAbzurechnendeMinuten := TIntegerField.Create(Self);
  xdsTicketsAbgerechneteMinuten := TIntegerField.Create(Self);
  xdsTicketsStatusStatus := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsTickets.BeforeLoadDFMValues;
  xdsTicketsStatus.BeforeLoadDFMValues;
  xdsTicketsID.BeforeLoadDFMValues;
  xdsTicketsErstelltAm.BeforeLoadDFMValues;
  xdsTicketsBetreff.BeforeLoadDFMValues;
  xdsTicketsBeschreibung.BeforeLoadDFMValues;
  xdsTicketsErledigtAm.BeforeLoadDFMValues;
  xdsTicketsLoesung.BeforeLoadDFMValues;
  xdsTicketsZeitaufwandMinuten.BeforeLoadDFMValues;
  xdsTicketsAbzurechnendeMinuten.BeforeLoadDFMValues;
  xdsTicketsAbgerechneteMinuten.BeforeLoadDFMValues;
  xdsTicketsStatusStatus.BeforeLoadDFMValues;
  try
    Name := 'Tickets';
    Width := 169;
    Height := 250;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 145;
    TC.Height := 217;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsTickets.SetParentComponent(Self);
    xdsTickets.Name := 'xdsTickets';
    xdsTickets.AfterOpen := xdsTicketsAfterOpen;
    xdsTickets.EntitySetName := 'ITS_TicketMain';
    xdsTickets.Connection := DM2.XDataWebConnection1;
    xdsTickets.SubpropsDepth := 1;
    xdsTickets.QueryString := '$expand=Status';
    xdsTickets.Left := 40;
    xdsTickets.Top := 40;
    xdsTicketsStatus.SetParentComponent(xdsTickets);
    xdsTicketsStatus.Name := 'xdsTicketsStatus';
    xdsTicketsStatus.FieldName := 'Status';
    xdsTicketsID.SetParentComponent(xdsTickets);
    xdsTicketsID.Name := 'xdsTicketsID';
    xdsTicketsID.FieldName := 'ID';
    xdsTicketsID.Required := True;
    xdsTicketsErstelltAm.SetParentComponent(xdsTickets);
    xdsTicketsErstelltAm.Name := 'xdsTicketsErstelltAm';
    xdsTicketsErstelltAm.FieldName := 'ErstelltAm';
    xdsTicketsBetreff.SetParentComponent(xdsTickets);
    xdsTicketsBetreff.Name := 'xdsTicketsBetreff';
    xdsTicketsBetreff.FieldName := 'Betreff';
    xdsTicketsBetreff.Size := 100;
    xdsTicketsBeschreibung.SetParentComponent(xdsTickets);
    xdsTicketsBeschreibung.Name := 'xdsTicketsBeschreibung';
    xdsTicketsBeschreibung.FieldName := 'Beschreibung';
    xdsTicketsBeschreibung.Size := 255;
    xdsTicketsErledigtAm.SetParentComponent(xdsTickets);
    xdsTicketsErledigtAm.Name := 'xdsTicketsErledigtAm';
    xdsTicketsErledigtAm.FieldName := 'ErledigtAm';
    xdsTicketsLoesung.SetParentComponent(xdsTickets);
    xdsTicketsLoesung.Name := 'xdsTicketsLoesung';
    xdsTicketsLoesung.FieldName := 'Loesung';
    xdsTicketsLoesung.Size := 255;
    xdsTicketsZeitaufwandMinuten.SetParentComponent(xdsTickets);
    xdsTicketsZeitaufwandMinuten.Name := 'xdsTicketsZeitaufwandMinuten';
    xdsTicketsZeitaufwandMinuten.FieldName := 'ZeitaufwandMinuten';
    xdsTicketsAbzurechnendeMinuten.SetParentComponent(xdsTickets);
    xdsTicketsAbzurechnendeMinuten.Name := 'xdsTicketsAbzurechnendeMinuten';
    xdsTicketsAbzurechnendeMinuten.FieldName := 'AbzurechnendeMinuten';
    xdsTicketsAbgerechneteMinuten.SetParentComponent(xdsTickets);
    xdsTicketsAbgerechneteMinuten.Name := 'xdsTicketsAbgerechneteMinuten';
    xdsTicketsAbgerechneteMinuten.FieldName := 'AbgerechneteMinuten';
    xdsTicketsStatusStatus.SetParentComponent(xdsTickets);
    xdsTicketsStatusStatus.Name := 'xdsTicketsStatusStatus';
    xdsTicketsStatusStatus.FieldName := 'Status.Status';
    xdsTicketsStatusStatus.Size := 25;
  finally
    TC.AfterLoadDFMValues;
    xdsTickets.AfterLoadDFMValues;
    xdsTicketsStatus.AfterLoadDFMValues;
    xdsTicketsID.AfterLoadDFMValues;
    xdsTicketsErstelltAm.AfterLoadDFMValues;
    xdsTicketsBetreff.AfterLoadDFMValues;
    xdsTicketsBeschreibung.AfterLoadDFMValues;
    xdsTicketsErledigtAm.AfterLoadDFMValues;
    xdsTicketsLoesung.AfterLoadDFMValues;
    xdsTicketsZeitaufwandMinuten.AfterLoadDFMValues;
    xdsTicketsAbzurechnendeMinuten.AfterLoadDFMValues;
    xdsTicketsAbgerechneteMinuten.AfterLoadDFMValues;
    xdsTicketsStatusStatus.AfterLoadDFMValues;
  end;
end;

end.